module.exports = __webpack_public_path__ + "img/iliosForm.c6dd107a.svg";